import { render, staticRenderFns } from "./dataCount.vue?vue&type=template&id=20a8867a&scoped=true"
import script from "./dataCount.vue?vue&type=script&lang=js"
export * from "./dataCount.vue?vue&type=script&lang=js"
import style0 from "./dataCount.vue?vue&type=style&index=0&id=20a8867a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8867a",
  null
  
)

export default component.exports